import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CssIcon(props: IconProps) {
    return <Icon {...props} iconKey={"css"}/>
}
